import ClientNotificationInterface from '../../interfaces/client/Notification'

export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'

export default (notifications: ClientNotificationInterface[]) => ({
  type: ADD_NOTIFICATIONS,
  notifications,
})
